(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Load only the visible Engineering film. Keep its still until frames play. */
  var films = [].slice.call(document.querySelectorAll('.pu-why-eng-panel video'));
  function eligible(film) {
    return film.dataset.inView === 'true' && !film.closest('[hidden]') && !document.hidden && !reduce;
  }
  function syncFilm(film) {
    if (!eligible(film)) { film.pause(); return; }
    if (film.error || film.dataset.failed) return;
    var source = film.querySelector('source');
    if (source && !source.getAttribute('src')) {
      source.src = source.dataset.src;
      film.load();
    }
    film.muted = true;
    film.defaultMuted = true;
    film.playsInline = true;
    var playing = film.play();
    if (playing) playing.catch(function () { film.classList.remove('is-playing'); });
  }
  films.forEach(function (film) {
    film.addEventListener('playing', function () {
      if (eligible(film)) film.classList.add('is-playing');
      else film.pause();
    });
    ['pause', 'waiting', 'error', 'emptied'].forEach(function (event) {
      film.addEventListener(event, function () { film.classList.remove('is-playing'); });
    });
    var source = film.querySelector('source');
    if (source) source.addEventListener('error', function () {
      film.dataset.failed = 'true';
      film.classList.remove('is-playing');
      film.pause();
    });
  });
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.dataset.inView = String(entry.isIntersecting);
        syncFilm(entry.target);
      });
    });
    films.forEach(function (film) { observer.observe(film); });
  }
  document.addEventListener('visibilitychange', function () { films.forEach(syncFilm); });

  /* Keep the original poster while YouTube connects, including slow phones. */
  var filmTrigger = document.querySelector('[data-why-film-play]');
  if (filmTrigger) {
    var container = filmTrigger.closest('[data-why-film]');
    var feedback = document.querySelector('[data-why-film-feedback]');
    var status = feedback.querySelector('[role="status"]');
    var apiPromise;
    function youtubeAPI() {
      if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
      if (apiPromise) return apiPromise;
      apiPromise = new Promise(function (resolve, reject) {
        var previous = window.onYouTubeIframeAPIReady;
        var script = document.createElement('script');
        window.onYouTubeIframeAPIReady = function () {
          if (previous) previous();
          resolve(window.YT);
        };
        script.src = 'https://www.youtube.com/iframe_api';
        script.onerror = function () { script.remove(); apiPromise = null; reject(new Error('Video unavailable')); };
        document.head.appendChild(script);
      });
      return apiPromise;
    }
    filmTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (container.dataset.state === 'loading') return;
      container.dataset.state = 'loading';
      container.setAttribute('aria-busy', 'true');
      feedback.hidden = false;
      status.textContent = 'Loading video…';
      var active = true;
      var player;
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/7apx_kBkElY?autoplay=1&playsinline=1&rel=0&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin);
      frame.title = 'How Oxydise works';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.tabIndex = -1;
      container.appendChild(frame);
      function fallback() {
        if (!active) return;
        active = false;
        clearTimeout(timer);
        if (player) player.destroy();
        frame.remove();
        container.dataset.state = 'error';
        container.removeAttribute('aria-busy');
        filmTrigger.hidden = false;
        filmTrigger.setAttribute('aria-label', 'Retry How Oxydise works video');
        status.textContent = 'The video could not load. Tap play to retry, or watch on YouTube.';
      }
      var timer = setTimeout(fallback, 15000);
      frame.addEventListener('error', fallback);
      youtubeAPI().then(function (YT) {
        if (!active) return;
        player = new YT.Player(frame, { events: {
          onReady: function () {
            if (!active) return;
            clearTimeout(timer);
            container.dataset.state = 'ready';
            container.removeAttribute('aria-busy');
            filmTrigger.hidden = true;
            frame.tabIndex = 0;
            frame.focus();
            status.textContent = 'Tap play in the video if it does not start.';
          },
          onStateChange: function (event) {
            if (active && event.data === 1) status.textContent = '';
          },
          onAutoplayBlocked: function () {
            if (active) status.textContent = 'Tap play in the video to start.';
          },
          onError: fallback
        }});
      }).catch(fallback);
    });
  }

  /* Engineering tabs retain their poster when motion or playback is unavailable. */
  var tabs = [].slice.call(document.querySelectorAll('[data-eng-tab]'));
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (o) {
        var on = o === t;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        var pane = document.getElementById('pu-eng-panel-' + o.dataset.engTab);
        if (pane) pane.hidden = !on;
      });
      films.forEach(syncFilm);
    });
  });
})();
